















import { Component, Mixins, Prop } from "vue-property-decorator";
import { LineWidthDropDownSelector } from "../../../../../components/drawing";
import { ModelEditableMixin } from "../../../../../components/system";
import { StandardOption } from "../../../../../components/system/selectors/mixins";
import ColorPicker from "../../../../../components/drawing/ColorPicker.vue";
import { LineStyle, Color } from "../../../../../domain/drawing";

@Component({
  components: {
    colorPicker: ColorPicker,
    widthSelector: LineWidthDropDownSelector,
  },
})
export default class SignStyleEditor extends Mixins(ModelEditableMixin) {
  editingSource: LineStyle;

  @Prop()
  pallet: Color[];

  @Prop()
  options: StandardOption<any>[];

  get color(): Color {
    return this.editingSource
      ? this.editingSource.color
      : undefined;
  }

  set color(value: Color) {
    this.writePropertyWhenValid(s => s.color = value);
  }

  get width(): number {
    return this.editingSource
      ? this.editingSource.width
      : undefined;
  }

  set width(value: number) {
    this.writePropertyWhenValid(s => s.width = value);
  }

  get defaultColor(): Color {
    return this.editingSource
      ? new Color(this.editingSource.color.value)
      : new Color("#FF0000");
  }
}
